import { HttpClient } from '@wix/http-client';
import React, { Suspense, useEffect, useState } from 'react';
import { defaultMainHeaderTexts, links, MainLinkId } from './constants';
import { LinkItem } from './LinkItem';
import s from './main-header.scss';
import { MobileMenuToggle } from './MobileMenuToggle';
import { SignInButton } from './SignInButton';
import { getActiveLink, getCookie, getUserDetails } from './utils';
import { WixDevelopersLogo } from './WixDevelopersLogo';
import { Box, Button, WixStyleReactProvider } from 'wix-style-react';
import { LinksMenu } from './LinksMenu';
import { getApiAndSdk, getApiReference, getAppMarket, getAppTemplate, getBuildAppDoc, getMyApps, getResources, getSupport, } from './selectors';
const UserDetails = React.lazy(() => import('./UserDetails'));
const httpClient = new HttpClient();
export const MainHeader = ({ textOverrides, experiments, afterLoginLink, afterLogoutLink, }) => {
    const activeLinkId = getActiveLink(window.location.href);
    const isAppTemplateExperimentIsOn = experiments && experiments['specs.dcc.appTemplates'] === 'true';
    const [linksData, setLinksData] = useState([
        {
            id: MainLinkId.MyApps,
            text: getMyApps(textOverrides) || getMyApps(defaultMainHeaderTexts) || '',
            href: getMyApps(links),
            active: activeLinkId === MainLinkId.MyApps,
            target: 'same-window',
        },
        ...(isAppTemplateExperimentIsOn
            ? [
                {
                    id: MainLinkId.Resources,
                    text: getResources(textOverrides) ||
                        getResources(defaultMainHeaderTexts) ||
                        '',
                    active: activeLinkId === MainLinkId.appTemplates,
                    children: [
                        {
                            id: MainLinkId.buildAppDoc,
                            text: getBuildAppDoc(textOverrides) ||
                                getBuildAppDoc(defaultMainHeaderTexts) ||
                                '',
                            active: activeLinkId === MainLinkId.buildAppDoc,
                            href: getBuildAppDoc(links),
                            target: 'new-window',
                        },
                        {
                            id: MainLinkId.apiAndSdk,
                            text: getApiAndSdk(textOverrides) ||
                                getApiAndSdk(defaultMainHeaderTexts) ||
                                '',
                            active: activeLinkId === MainLinkId.apiAndSdk,
                            href: getApiAndSdk(links),
                            target: 'new-window',
                        },
                        {
                            id: MainLinkId.appTemplates,
                            text: getAppTemplate(textOverrides) ||
                                getAppTemplate(defaultMainHeaderTexts) ||
                                '',
                            active: activeLinkId === MainLinkId.appTemplates,
                            href: getAppTemplate(links),
                            target: 'same-window',
                        },
                    ],
                },
            ]
            : [
                {
                    id: MainLinkId.ApiReference,
                    text: getApiReference(textOverrides) ||
                        getApiReference(defaultMainHeaderTexts) ||
                        '',
                    href: getApiReference(links),
                    active: activeLinkId === MainLinkId.ApiReference,
                    target: 'new-window',
                },
                {
                    id: MainLinkId.Support,
                    text: getSupport(textOverrides) ||
                        getSupport(defaultMainHeaderTexts) ||
                        '',
                    href: getSupport(links),
                    active: activeLinkId === MainLinkId.Support,
                    target: 'new-window',
                },
            ]),
        {
            id: MainLinkId.AppMarket,
            text: getAppMarket(textOverrides) ||
                getAppMarket(defaultMainHeaderTexts) ||
                '',
            href: getAppMarket(links),
            active: activeLinkId === MainLinkId.AppMarket,
            target: 'new-window',
        },
    ]);
    const userLoggedIn = getCookie('wixClient') !== null;
    const [userDetails, setUserDetails] = useState(null);
    const discordLink = {
        id: MainLinkId.Discord,
        text: textOverrides?.mainLinks?.discord ||
            defaultMainHeaderTexts.mainLinks.discord,
        href: links.mainLinks.discord,
        active: activeLinkId === MainLinkId.Discord,
        target: 'new-window',
    };
    useEffect(() => {
        if (userLoggedIn) {
            getUserDetails({ httpClient }).then((user) => {
                setUserDetails(user);
                if (user?.isWixUser) {
                    setLinksData((prevLinks) => [
                        ...prevLinks,
                        {
                            id: MainLinkId.PermissionCatalog,
                            text: textOverrides?.mainLinks?.permissionCatalog ||
                                defaultMainHeaderTexts.mainLinks.permissionCatalog,
                            href: links.mainLinks.permissionCatalog,
                            active: activeLinkId === MainLinkId.PermissionCatalog,
                            target: 'new-window',
                        },
                    ]);
                }
            });
        }
    }, []);
    return (React.createElement(Suspense, { fallback: null },
        React.createElement(WixStyleReactProvider, { features: { newColorsBranding: true } },
            React.createElement("header", { className: s.headerNewStyle, "data-hook": "main-header" },
                React.createElement(WixDevelopersLogo, null),
                React.createElement(MobileMenuToggle, null),
                React.createElement("nav", { className: s.navigation },
                    React.createElement("ul", { className: s.navigationLinksNewStyle }, linksData.map((linkData) => {
                        return linkData.children ? (React.createElement(LinksMenu, { key: linkData.id, ...linkData })) : (React.createElement(LinkItem, { key: linkData.id, ...linkData }));
                    })),
                    React.createElement("ul", { className: s.discordLink },
                        React.createElement(LinkItem, { key: discordLink.id, ...discordLink })),
                    React.createElement(Box, { paddingRight: "15px" },
                        React.createElement(Button, { as: "a", href: "https://devforum.wix.com/kb/en/contact", target: "_blank", skin: "dark", priority: "secondary", size: "small" }, "Contact Us")),
                    React.createElement("div", { className: `${s.userDetailsMenu} ${userLoggedIn ? '' : s.userDetailsNotLoggedIn}` }, userLoggedIn ? (userDetails && (React.createElement(UserDetails, { user: userDetails, afterLogoutLink: afterLogoutLink }))) : (React.createElement(SignInButton, { afterLoginLink: afterLoginLink, text: textOverrides?.signInButton ||
                            defaultMainHeaderTexts.signInButton }))))))));
};
//# sourceMappingURL=MainHeader.js.map